module.exports = __webpack_public_path__ + "media/images/pic/worker-ac48c79a7577cb1cffcd8b5affd04d0b.jpg";